import * as React from "react";

import { Sendum } from "../../Sendum";
import { Button } from "../../components";
import { User } from "../../models";

import classes from "./HeaderComponent.module.scss";

const HeaderComponent = () => {

	const onClickAuthButtonHandler = () => {
		const user = new User();
		if (user.isAuthorized()) {
			user.logout();
		} else {
			Sendum.getBrowserHistory().push("/login");
		}
	};

	const getAuthButtonTitle = (): string => (new User().isAuthorized() ? "Logout" : "Login");

	return (
		<div className={classes.header}>
			<div className={classes.header__row}>
				<div className={classes.header__whitelabel}>whitelabel</div>
				<div className={classes.header__help}>
					<Button title={"Help"} />
				</div>
				<div className={classes.header__emptySpace} />
				<div className={classes.header__username}>username</div>
				<div className={classes.header__authButtonContainer}>
					<Button title={getAuthButtonTitle()} onClick={onClickAuthButtonHandler} />
				</div>
			</div>
		</div>
	);
};

export default HeaderComponent;
